export default "__VITE_ASSET__c645483c__"